import { jsx } from 'react/jsx-runtime';
import React__default from 'react';

var ComposedWidgetLink = function ComposedWidgetLink(props) {
  var handleClick = React__default.useCallback(function (e) {
    if (e.currentTarget.href) {
      e.preventDefault();
      if (props.href) {
        props.redirectCallback(props.href);
      }
    }
  }, [props.href, props.redirectCallback]);
  return jsx("a", Object.assign({}, props, {
    onClick: handleClick,
    children: props.children
  }));
};

export { ComposedWidgetLink as default };
